<nav class="bottom-nav">
    @for (item of navItems; track item.route) {
    <a [routerLink]="item.route" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: item.exact }"
        class="nav-item" [attr.aria-label]="item.label">
        <div class="nav-icon-wrapper">
            <span class="nav-icon">{{ item.icon }}</span>
            @if (item.showBadge && cartItemCount() > 0) {
            <span class="cart-badge">{{ cartItemCount() }}</span>
            }
        </div>
        <span class="nav-label">{{ item.label }}</span>
    </a>
    }
</nav>